import { Injectable, ChangeDetectorRef } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class AlertService {
  private alerts: any[] = [];
  private alertsSubject: Subject<any[]> = new BehaviorSubject<any[]>(this.alerts);

  constructor() {}

  getAlerts(): Observable<any[]> {
    return this.alertsSubject;
  }

  addAlert(alert): void {
    this.alerts.push(alert);
    this.alertsSubject.next(this.alerts);
  }

  removeAlert(index): void {
    this.alerts.splice(index, 1);
    this.alertsSubject.next(this.alerts);
  }

  removeAll(): void {
    this.alerts = [];
    this.alertsSubject.next(this.alerts);
  }

  createAlertObj(error): any {
    let alert = {
      type: 'warning' as string,
      timeout: null as number,
      message: '' as string
    };

    if (error.code == 'INVALID_REQUEST') {
      alert.type = 'danger';
      alert.timeout = 5000;
      alert.message = error.description;
    }

    return alert;
  }

  createCustomAlertObj(message: string, type?: string, timeout?: number): any {
    let alert = {
      type: type == 'error' ? 'danger' : type ? type : ('info' as string),
      timeout: timeout !== undefined ? timeout : (3000 as number),
      message: message as string
    };

    return alert;
  }
}
